export default {
  en: {
    AfterCallIndexScene: {
      title: 'After calls',
    },
  },
};
